import { gql, useQuery } from '@apollo/client';

export const HAS_PAYMENT_METHOD_QUERY = gql`
  query hasPaymentMethod {
    hasPaymentMethod
  }
`;

export const useHasPaymentMethodQuery = () => {
  const { data, error, loading } = useQuery(HAS_PAYMENT_METHOD_QUERY);

  return {
    error,
    hasPaymentMethod: data?.hasPaymentMethod,
    loading,
  };
};
